// c_animated_text: as the section scrolls up through the viewport, the items
// ease from a centered cluster out to their full-width (space-between) spread.
// Driven by scroll progress so it's reversible and tied to the scroll position.
// The base layout is the final spread; each item is translated toward the
// centered layout by (1 - progress), so progress 0 = centered, 1 = spread.
(function () {
  function setup(container) {
    var items = Array.prototype.slice.call(
      container.querySelectorAll(".animated_item")
    );
    if (items.length < 2) return; // nothing to spread

    var offsets = [];

    // Measure each item's centre in BOTH layouts (centered vs spread) and store
    // the horizontal delta. Wrapping (line composition) is identical between
    // the two, so only the horizontal distribution differs.
    function measure() {
      items.forEach(function (it) { it.style.transform = ""; });

      container.style.justifyContent = "center";
      var centered = items.map(function (it) {
        var r = it.getBoundingClientRect();
        return r.left + r.width / 2;
      });

      container.style.justifyContent = "space-between";
      var spread = items.map(function (it) {
        var r = it.getBoundingClientRect();
        return r.left + r.width / 2;
      });

      container.style.justifyContent = ""; // back to the stylesheet (space-between)
      offsets = items.map(function (_, i) { return centered[i] - spread[i]; });
    }

    function apply() {
      var rect = container.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var center = rect.top + rect.height / 2;
      // progress: 0 when the section centre is at the bottom of the viewport,
      // 1 by the time it reaches the vertical middle.
      var p = (vh - center) / (vh * 0.5);
      p = p < 0 ? 0 : (p > 1 ? 1 : p);

      items.forEach(function (it, i) {
        var dx = offsets[i] * (1 - p);
        it.style.transform = "translateX(" + dx + "px)";
      });
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { apply(); ticking = false; });
    }

    measure();
    apply();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () { measure(); apply(); });
    window.addEventListener("load", function () { measure(); apply(); });
  }

  function init() {
    document.querySelectorAll(".c_animated_text").forEach(setup);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
